import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import CustomGrid from "../../components/grid/CustomGrid";
import RowSwitch from "../../components/grid/RowSwitch";
export default function UserRepList() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (companyId > 0) {
      getUsers();
    }
  }, [companyId]);

  const getUsers = async () => {
    try {
      let url = "";

      setIsLoading(true);
      if (currentUser.isAdmin) {
        url = `${companyId}/usersRep`;
      }

      const res = await userRequest.get(url);

      setData(res.data);
    } catch (error) {
      console.error(error.code);
      if (error.code === 403) {
        nav(`../login`);
      }
    }
    setIsLoading(false);
  };

  const deleteUsr = async (usr, del) => {
    //const res = await userRequest.delete(`${companyId}/users/${usr}`);

    let delToogle = { deleted: null };
    if (del) {
      delToogle = { deleted: new Date(), lastUserUpdate: currentUser.userId };
    }

    const res = await userRequest.put(
      `${companyId}/usersRep/${usr}`,
      delToogle
    );

    if (res.data > 0) {
      getUsers();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar usuário!", "error");
    }
  };

  const onButtonDeleteClickNew = (row, newValue) => {
    if (currentUser.isAdmin) {
      if (newValue) {
        Swal.fire({
          title: "Tem certeza que deseja inativar?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, inativar!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            deleteUsr(row, true);
          } else {
            getUsers();
          }
        });
      } else {
        deleteUsr(row, false);
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para inativar usuário!",
        "warning"
      );
    }
  };
  const onButtonDeleteClick = (e, row) => {
    if (currentUser.isAdmin) {
      if (!e.target.checked) {
        Swal.fire({
          title: "Tem certeza que deseja inativar?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, inativar!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            deleteUsr(row, true);
          } else {
            getUsers();
          }
        });
      } else {
        deleteUsr(row, false);
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para inativar usuário!",
        "warning"
      );
    }
  };

  const onButtonEditarClick = (e, row) => {
    nav(window.location.pathname.replace("tabconfigs", "usersRep") + "/" + row);
  };

  const nav = useNavigate();
  const addRow = () => {
    nav(`../usersRep/new`);
  };

  const columns = [
    {
      field: "userRepId",
      type: "number",
      headerName: "ID",
      width: 50,
      align: "center",
      headerAlign: "center",
      clickable: true,
    },
    {
      field: "name",
      type: "text",
      headerName: "Nome",
      width: 150,
      align: "left",
      headerAlign: "left",
      clickable: true,
    },
    {
      field: "email",
      type: "text",
      headerName: "Email",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "contact",
      type: "text",
      headerName: "Contato",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "username",
      type: "text",
      headerName: "Nome de Usuário",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "cpf",
      type: "text",
      headerName: "CPF",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "createdAt",
      type: "date",
      headerName: "Criada em",
      width: 100,
      align: "left",
      format: "dd/MM/yyyy",
    },
    {
      field: "updatedAt",
      type: "date",
      headerName: "Atualizada em",
      width: 100,
      align: "left",
      format: "dd/MM/yyyy",
    },
    {
      field: "deleted",
      type: "date",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        if (!currentUser.isAdmin) return null;
        return (
          <RowSwitch
            value={row.deleted}
            userId={row.userRepId}
            onChange={onButtonDeleteClickNew} // sem mudanças
          />
        );
      },
    },
  ];
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Representantes</div>
          <div className="cust-card">
            <div className="cust-section-header">Lista de Representantes</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                toolbarActions={
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={addRow}
                    size="small"
                  >
                    Adicionar Representante
                  </Button>
                }
                gridId="userRepList"
                rows={data}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
                onRowClick={(row) =>
                  nav(
                    window.location.pathname.replace("tabconfigs", "usersRep") +
                      "/" +
                      row.userRepId
                  )
                }
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
